import { render, staticRenderFns } from "./uiobs3Motivos.vue?vue&type=template&id=2e2971c3"
import script from "./uiobs3Motivos.vue?vue&type=script&lang=js"
export * from "./uiobs3Motivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports